import React, { useRef, useState } from "react";
import UserAvatar from "./UserAvatar";
import { Link, useLocation } from "react-router-dom";
import { Menu, ArrowUpRight, ChevronRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import Sidebar from "./Sidebar";
import NotificationBell from "./NotificationBell";
import { Button } from "./ui/button";

const PAGE_NAMES = {
  dashboard: "Overview",
  events: "Events",
  tasks: "Tasks",
  calendar: "Calendar",
  employees: "Employees",
  institutions: "Institutions",
  equipment: "Equipment",
  users: "Users",
  "create-user": "Create user",
  "my-tasks": "My tasks",
  "my-calendar": "My calendar",
  "change-password": "Account settings",
};
export default function Layout({ children }) {
  const { user, isMediaHead } = useAuth();
  const { pathname } = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const menuRef = useRef(null);
  const home = isMediaHead ? "/dashboard" : "/my-tasks";
  const section = PAGE_NAMES[pathname.split("/")[1]] || "Workspace";
  return (
    <div className="studio-app">
      <a className="skip-link" href="#main-content">
        Skip to content
      </a>
      <header className="studio-topbar">
        <div className="brand-area">
          <Button
            ref={menuRef}
            variant="ghost"
            size="icon"
            className="lg:hidden"
            aria-label="Open navigation"
            aria-expanded={sidebarOpen}
            onClick={() => setSidebarOpen(true)}
            data-testid="mobile-menu-button"
          >
            <Menu />
          </Button>
          <Link to={home} className="studio-brand" aria-label="SMV Media home">
            <img className="brand-logo" src={`${process.env.PUBLIC_URL}/favicon.png`} alt="SMVEC logo" width="38" height="38" />
            <span>SMV Media</span>
          </Link>
        </div>
        <div className="header-context">
          <span>Workspace</span>
          <ChevronRight size={14} />
          <strong>{section}</strong>
        </div>
        <div className="topbar-actions">
          <Link to="/deliveries" className="public-gallery-link">
            Delivery gallery <ArrowUpRight size={15} />
          </Link>
          <div className="topbar-notification">
            <NotificationBell />
          </div>
          <Link
            to="/change-password"
            className="profile-link"
            aria-label={`Account settings for ${user?.name || "your account"}`}
          >
            <UserAvatar id={user?.id} name={user?.name} size={36} className="profile-avatar" />
            <span className="profile-copy">
              <strong>{user?.name}</strong>
              <span>{user?.role?.replaceAll("_", " ")}</span>
            </span>
          </Link>
        </div>
      </header>
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        menuRef={menuRef}
      />
      <main id="main-content" tabIndex={-1} className="studio-main">
        {children}
      </main>
    </div>
  );
}
